module.exports = __webpack_public_path__ + "static/media/oudsatinmood.bd059ad3.png";